'use strict';
import * as $j_app$002ecomponents$002einstances$0024package$0024$0024anon$00247 from "./app.components.instances$package$$anon$7.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_components_instances$package$() {
  this.axk = null;
  this.axl = false;
}
export { $c_Lapp_components_instances$package$ as $c_Lapp_components_instances$package$ };
$p = $c_Lapp_components_instances$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_components_instances$package$;
/** @constructor */
function $h_Lapp_components_instances$package$() {
}
export { $h_Lapp_components_instances$package$ as $h_Lapp_components_instances$package$ };
$h_Lapp_components_instances$package$.prototype = $p;
$p.af7 = (function() {
  if ((!this.axl)) {
    this.axk = new $j_app$002ecomponents$002einstances$0024package$0024$0024anon$00247.$c_Lapp_components_instances$package$$anon$7();
    this.axl = true;
  }
  return this.axk;
});
var $d_Lapp_components_instances$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_components_instances$package$, "app.components.instances$package$", ({
  yW: 1
}));
export { $d_Lapp_components_instances$package$ as $d_Lapp_components_instances$package$ };
var $n_Lapp_components_instances$package$;
function $m_Lapp_components_instances$package$() {
  if ((!$n_Lapp_components_instances$package$)) {
    $n_Lapp_components_instances$package$ = new $c_Lapp_components_instances$package$();
  }
  return $n_Lapp_components_instances$package$;
}
export { $m_Lapp_components_instances$package$ as $m_Lapp_components_instances$package$ };
//# sourceMappingURL=app.components.instances$package$.js.map
